export const ENV = {
  APP_PROJECT: import.meta.env.VITE_APP_PROJECT || 'aurous',
  API_URL: import.meta.env.VITE_API_URL || '/api',
  APP_NAME: import.meta.env.VITE_APP_NAME || 'Aurous Labs',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
  NSFW: import.meta.env.VITE_NSFW === 'true',
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL || '',
  SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
  APP_URL: import.meta.env.VITE_APP_URL || '',
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN || '',
  DUB_PUBLISHABLE_KEY: import.meta.env.VITE_DUB_PUBLISHABLE_KEY || '',
  RUDDERSTACK_WRITE_KEY: import.meta.env.VITE_RUDDERSTACK_WRITE_KEY || '',
  RUDDERSTACK_DATA_PLANE_URL: import.meta.env.VITE_RUDDERSTACK_DATA_PLANE_URL || '',
  NODE_ENV: import.meta.env.MODE || 'development',
  APP_STAGE: import.meta.env.VITE_APP_STAGE || 'dev',
  // Mirror of the backend FEATURE_CHARACTERS_ENABLED flag. Default true; set
  // VITE_FEATURE_CHARACTERS_ENABLED=false at build time to hide the customer-
  // facing character surfaces (sidebar nav, mobile nav, playground rail +
  // create sheet). Admin character surfaces are left alone — the platform
  // team must keep moderating during a pause. Vite ARG declared in
  // apps/onlygold/Dockerfile so the bake-time value reaches the bundle.
  FEATURE_CHARACTERS_ENABLED: import.meta.env.VITE_FEATURE_CHARACTERS_ENABLED !== 'false',
  // Seedance video surface gate (same pattern as characters). Default true; the
  // CI sets VITE_FEATURE_VIDEO_ENABLED=false for the PRODUCTION build only, so
  // the playground Image|Video toggle + the "Animate" i2v action are hidden in
  // prod until we announce the feature — visible on preprod/dev. Vite ARG
  // declared in apps/onlygold/Dockerfile so the bake-time value reaches the bundle.
  FEATURE_VIDEO_ENABLED: import.meta.env.VITE_FEATURE_VIDEO_ENABLED !== 'false',
  // Stories, Ads and Slideshows are not build-time flags: the API's EXPERIMENTAL_FEATURES_ENABLED
  // switches them, read at runtime through useExperimentalFeatures().
} as const;
